// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2uoaF","label":"Completed_label__3QszS"};